import { FC, useEffect, useState } from 'react';
import { Card, CardContent, CardHeader } from '@mui/material';
import { SeriesLineOptions } from 'highcharts';
import { DeviceDetailedHealth } from 'types';
import SimpleLineGraph from 'components/SimpleLineGraph/SimpleLineGraph';

interface DeviceHealthVoltageTemperatureCardProps {
    health: DeviceDetailedHealth | null;
}

const getTemperatureLine = (health: DeviceDetailedHealth) => {
    const output = [];
    for (let i = 0; i < health.temps?.length; i++) {
        output.push({
            x: health.time[i],
            y: health.temps[i],
        });
    }
    return output;
};

const getVoltageLine = (health: DeviceDetailedHealth) => {
    const output = [];
    for (let i = 0; i < health.voltage?.length; i++) {
        output.push({
            x: health.time[i],
            y: health.voltage[i],
        });
    }
    return output;
};

const options = {
    yAxis: [
        {
            labels: {
                format: '{value}°F',
            },
            title: {
                text: 'Temperature',
            },
            opposite: true,
        },
        {
            labels: {
                format: '{value}V',
            },
            title: {
                text: 'Voltage',
            },
        },
    ],
};

const DeviceHealthVoltageTemperatureCard: FC<
    DeviceHealthVoltageTemperatureCardProps
> = ({ health }) => {
    const [series, setSeries] = useState<SeriesLineOptions[]>([]);

    useEffect(() => {
        if (!health) return;
        const tempSeries: SeriesLineOptions[] = [
            { type: 'line', color: '#ff7f0e', name: 'temperature' },
            { type: 'line', color: '#1f77b4', name: 'voltage', yAxis: 1 },
        ];
        tempSeries[0].data = getTemperatureLine(health);
        tempSeries[1].data = getVoltageLine(health);
        tempSeries[0].tooltip = {
            valueDecimals: 1,
            xDateFormat: '%b %e %l:%M %p',
        };
        tempSeries[1].tooltip = {
            valueDecimals: 1,
            xDateFormat: '%b %e %l:%M %p',
        };

        setSeries(tempSeries);
    }, [health]);

    return (
        <div data-testid="DeviceHealthVoltageTemperatureCard">
            <Card>
                <CardHeader title="Voltage/Temperature" />
                <CardContent>
                    <SimpleLineGraph series={series} options={options} />
                </CardContent>
            </Card>
        </div>
    );
};

export default DeviceHealthVoltageTemperatureCard;
